import { combineReducers } from 'redux';
import { get, find } from 'lodash';
import convert from 'xml-js';
import atob from 'atob';
import { findFirst } from 'obj-traverse/lib/obj-traverse';

import * as ActionTypes from '../../actions/ActionTypes';


export const adMarkersReducer = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.HLS_FRAG_CHANGED:
            const tagList = get(action.payload, 'frag.tagList', []);
            let markers = tagList.filter((tag) => (tag[0] === 'EXT-X-MARKER') ? tag[1] : false)

            let markersData = markers.map(marker => {
                let markerArray = marker[1].split(',');

                return markerArray;
            })

            markersData = markersData.map(marker => {
                const keys = marker.map(prop => {
                    const test = prop.split(/\=(?=(?:[^"]*"[^"]*")*[^"]*$)/g); // match only = not inside double quotes
                    return test[0]

                })
                const values = marker.map(prop => {
                    const test = prop.split(/\=(?=(?:[^"]*"[^"]*")*[^"]*$)/g); // match only = not inside double quotes
                    return test[1]

                })

                return Object.assign(...keys.map((k, i) => ({ [k.toLowerCase()]: values[i] })))
            })

            // normalize ad markers
            markersData.map((obj) => {
                if (obj.breakdur) obj.breakdur = parseFloat(obj.breakdur);
                if (obj.offset) obj.offset = parseFloat(obj.offset);
                if (obj.duration) obj.duration = parseFloat(obj.duration);

                if (obj.data) {
                    try {
                        obj.data = obj.data.substring(0, obj.data.length - 1); // trim first char (don't want the quote)
                        obj.data = obj.data.substring(1, obj.data.length); // trim first char (don't want the quote)
                        obj.data = (!!window && !!window.atob) ? window.atob(obj.data) : atob(obj.data);
                    } catch (e) {
                        console.error(e);
                        obj.data = '<?xml version="1.0" encoding="UTF-8" standalone="no"?><empty></empty>';
                    }

                    try {
                        obj.data = JSON.parse(convert.xml2json(obj.data));
                    } catch (e) {
                        console.error(e);
                        obj.data = {};
                    }

                    const clickThroughElements = findFirst(obj.data, 'elements', { 'name': 'ClickThrough'});
                    const clickThroughElement = find(clickThroughElements.elements, (obj) => (obj.type === 'text'))

                    obj.clickThroughURL = get(clickThroughElement, 'text');
                }

                return obj;
            })

            return markersData;
        default:
            return state;
    }
}


export const currentAdReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return action.payload;
        case ActionTypes.CLEAR_CURRENT_AD:
            return null;
        default:
            return state;
    }
}


export const currentAdPodReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_POD:
            return action.payload;
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
}


export const currentAdEndTimeReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_END_TIME:
            return action.payload;
        default:
            return state;
    }
}


export const adTimeRemainingReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_AD_TIME_REMAINING:
            return action.payload;
        default:
            return state;
    }
}


export const currentAdTimeRemainingReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_TIME_REMAINING:
            return action.payload;
        default:
            return state;
    }
}



export const adEndTimeReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_AD_END_TIME:
            return action.payload;
        default:
            return state;
    }
}


export const adClickHandlerReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_AD_CLICK_HANDLER:
            return action.payload;
        default:
            return state;
    }
}


export const trackingCallBreakStartReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_POD:
            return get(action.payload, 'data.elements[0].elements[0].elements[0].elements[0].elements[0].elements[0].elements[0].text')
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
}


export const trackingCallBreakEndReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD_POD:
            return get(action.payload, 'data.elements[0].elements[0].elements[0].elements[0].elements[0].elements[1].elements[0].text')
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
}


export const getVMAPTrackingUrl = (payload, eventName) => {
    const trackingFragments = get(payload, 'data.elements[0].elements')
    const adTrackingWrapper = find(trackingFragments, (o) => {
        return get(o, 'elements[0].elements[0].elements[0].attributes.followAdditionalWrappers');
    });
    const adDetails = get(adTrackingWrapper, 'elements[0].elements[0].elements[0].elements')
    const creatives = find(adDetails, (o) => {
        return (get(o, 'name') === 'Creatives');
    });
    const adTrackingDetails = get(creatives, 'elements[0].elements[0].elements');
    const trackingEvents = find(adTrackingDetails, (o) => {
        return (get(o, 'name') === 'TrackingEvents');
    })
    const completeEvent = find(get(trackingEvents, 'elements', []), (o) => {
        const event = get(o, 'attributes.event')
        return (event === eventName);
    })
    return get(completeEvent, 'elements[0].text');
}


export const trackingCallDefaultImpressionReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            const trackingFragments = get(action.payload, 'data.elements[0].elements')
            const adTrackingWrapper = find(trackingFragments, (o) => {
                return get(o, 'elements[0].elements[0].elements[0].attributes.followAdditionalWrappers');
            });
            const adDetails = get(adTrackingWrapper, 'elements[0].elements[0].elements[0].elements')
            const impression = find(adDetails, (o) => {
                return (get(o, 'name') === 'Impression');
            });
            return get(impression, 'elements[0].text');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
}


export const trackingCallFirstQuartileReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return getVMAPTrackingUrl(action.payload, 'firstQuartile');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
}


export const trackingCallMidpointReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return getVMAPTrackingUrl(action.payload, 'midpoint');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
}


export const trackingCallThirdQuartileReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return getVMAPTrackingUrl(action.payload, 'thirdQuartile');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
}


export const trackingCallCompleteReducer = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.SET_CURRENT_AD:
            return getVMAPTrackingUrl(action.payload, 'complete');
        case ActionTypes.CLEAR_CURRENT_AD_POD:
            return null;
        default:
            return state;
    }
}


export default combineReducers({
    adMarkers: adMarkersReducer,
    currentAd: currentAdReducer,
    currentAdPod: currentAdPodReducer,
    currentAdEndTime: currentAdEndTimeReducer,
    adTimeRemaining: adTimeRemainingReducer,
    currentAdTimeRemaining: currentAdTimeRemainingReducer,
    adEndTime: adEndTimeReducer,
    adClickHandler: adClickHandlerReducer,
    trackingCallBreakStart: trackingCallBreakStartReducer,
    trackingCallBreakEnd: trackingCallBreakEndReducer,
    trackingCallDefaultImpression: trackingCallDefaultImpressionReducer,
    trackingCallFirstQuartile: trackingCallFirstQuartileReducer,
    trackingCallMidpoint: trackingCallMidpointReducer,
    trackingCallThirdQuartile: trackingCallThirdQuartileReducer,
    trackingCallComplete: trackingCallCompleteReducer,
});


// WEBPACK FOOTER //
// ./src/ads/auditude/reducer.js